import { cn } from '@/lib/utils'
import { Icon } from '@/icons/Icon'

type ExternalIndicatorProps = {
  className?: string
  // Skips the hidden/hover-reveal gating so the indicator renders visibly with no
  // ancestor `.group` hover needed — for touch contexts where hover never fires.
  alwaysVisible?: boolean
  // Reveal on a named `group/row` ancestor instead of the nearest `group`, so a wide
  // hover area (e.g. a clickable list row) doesn't also trigger unrelated group-hovers
  rowGroup?: boolean
}

export default function ExternalIndicator({
  className,
  alwaysVisible,
  rowGroup,
}: ExternalIndicatorProps) {
  return (
    <div
      className={cn(
        'flex overflow-hidden transition-[max-width] duration-300 ease-in-out',
        alwaysVisible
          ? 'max-w-4 shrink-0'
          : rowGroup
            ? 'hidden max-w-0 group-hover/row:max-w-4 md:flex'
            : 'hidden max-w-0 group-hover:max-w-4 md:flex',
      )}
    >
      <Icon
        name="arrow-up-right"
        size={10}
        className={cn(
          'shrink-0 transition-transform duration-300 ease-in-out',
          alwaysVisible
            ? 'scale-100'
            : rowGroup
              ? 'ml-1.5 scale-0 group-hover/row:scale-100'
              : 'ml-1.5 scale-0 group-hover:scale-100',
          className,
        )}
      />
    </div>
  )
}
